import { render, staticRenderFns } from "./PeriodPatientTherpiesList.vue?vue&type=template&id=4193710d"
import script from "./PeriodPatientTherpiesList.vue?vue&type=script&lang=ts"
export * from "./PeriodPatientTherpiesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports